import type { MouseEvent } from 'react'

export const DRIVE_BROWSE_SCOPE_EVENT = 'maater-drive-browse-scope'
export const DRIVE_GO_UP_EVENT = 'maater-drive-go-up'
export const OPEN_DRIVE_PREVIEW_EVENT = 'maater-open-drive-preview'
export const DRIVE_FOCUS_WORKSPACE_EVENT = 'maater-drive-focus-workspace'
export const DRIVE_MAIN_SURFACE_EVENT = 'maater-drive-main-surface'

export type DriveMainSurface = 'drive' | 'activity' | 'linked'

export type DriveBrowseScopeKind = 'myDrive' | 'sharedDrives' | 'recent'

export type DriveBrowseScopeDetail = {
  workspaceId: string
  viewKind: DriveBrowseScopeKind | 'sharedDrive'
  folderId?: string
  driveId?: string
  driveName?: string
  /** Select this row in the main list without entering it. */
  selectId?: string
  openPreview?: boolean
  /** tree = sidebar jump (main listens). main = folder view nav (tree listens). */
  source?: 'tree' | 'main'
}

export type OpenDrivePreviewDetail = {
  file: {
    id: string
    name: string
    mimeType: string
    webViewLink?: string
    shortcutTarget?: { id: string; mimeType: string } | null
  }
  organizationId: string
  event?: MouseEvent
  importedDocumentId?: string
}

export function dispatchOpenDrivePreview(detail: OpenDrivePreviewDetail) {
  window.dispatchEvent(new CustomEvent(OPEN_DRIVE_PREVIEW_EVENT, { detail }))
}

export function dispatchDriveFocusWorkspace(workspaceId: string) {
  if (!workspaceId) return
  window.dispatchEvent(
    new CustomEvent(DRIVE_FOCUS_WORKSPACE_EVENT, { detail: { workspaceId } }),
  )
}

export type DriveMainSurfaceDetail = {
  workspaceId?: string
  surface: DriveMainSurface
}

let lastDriveMainSurface: DriveMainSurface = 'drive'
/** Tree jump that has not been applied by a mounted folder view yet. */
let pendingTreeOpen: DriveBrowseScopeDetail | null = null

export function getLastDriveMainSurface(): DriveMainSurface {
  return lastDriveMainSurface
}

/** Read and clear a sidebar folder jump that fired before the folder view mounted. */
export function consumePendingDriveTreeOpen(): DriveBrowseScopeDetail | null {
  const pending = pendingTreeOpen
  pendingTreeOpen = null
  return pending
}

export function dispatchDriveBrowseScope(detail: DriveBrowseScopeDetail) {
  lastDriveMainSurface = 'drive'
  if (detail.source === 'tree') pendingTreeOpen = detail
  window.dispatchEvent(new CustomEvent(DRIVE_BROWSE_SCOPE_EVENT, { detail }))
}

export function dispatchDriveGoUp() {
  window.dispatchEvent(new Event(DRIVE_GO_UP_EVENT))
}

export function dispatchDriveMainSurface(detail: DriveMainSurfaceDetail) {
  if (!detail.surface) return
  lastDriveMainSurface = detail.surface
  window.dispatchEvent(new CustomEvent(DRIVE_MAIN_SURFACE_EVENT, { detail }))
}
